import React from 'react';
import { ReviewCaseDetails } from 'pages/components';

const ARContactNewCaseReview = (props) => (
  <ReviewCaseDetails {...props} />
);

export default ARContactNewCaseReview;
